import { OAUTH_API_URL } from './apiUrls';

// Load token and expiration time from localStorage
let accessToken: string | null = localStorage.getItem('accessToken');
let tokenExpirationTime: number | null = localStorage.getItem('tokenExpirationTime')
	? parseInt(localStorage.getItem('tokenExpirationTime')!)
	: null;

let refreshTimeout: ReturnType<typeof setTimeout> | null = null;

export const fetchAccessToken = async (): Promise<void> => {
	try {
		const response = await fetch(OAUTH_API_URL, {
			method: 'GET',
		});

		if (!response.ok) {
			throw new Error(`Failed to fetch access token: ${response.statusText}`);
		}

		const data = await response.json();

		console.log('oauth response: ', data);
		const { id: access_token, expires_in, issued_at } = data;

		if (!access_token || !expires_in || !issued_at) {
			throw new Error('Access token, expiration time, or issued_at is missing');
		}

		accessToken = access_token;
		// Calculate the absolute expiration time using the server-provided issued_at and expires_in
		tokenExpirationTime = parseInt(issued_at) + parseInt(expires_in) * 1000;

		if (accessToken) {
			localStorage.setItem('accessToken', accessToken);
		}
		if (tokenExpirationTime) {
			localStorage.setItem('tokenExpirationTime', tokenExpirationTime.toString());
		}

		// Schedule a refresh based on the new expiration time
		scheduleTokenRefresh(parseInt(expires_in));
	} catch (error) {
		console.error('Error fetching access token:', error);
		throw error;
	}
};

const scheduleTokenRefresh = (expiresIn: number) => {
	if (refreshTimeout) {
		clearTimeout(refreshTimeout);
	}

	// Calculate the refresh time to be slightly before the token actually expires
	const refreshTime = (expiresIn - 60) * 1000;
	refreshTimeout = setTimeout(async () => {
		await fetchAccessToken();
	}, refreshTime);
};

export const getAccessToken = async (): Promise<string> => {
	if (!accessToken || !tokenExpirationTime || Date.now() >= tokenExpirationTime) {
		await fetchAccessToken();
	}
	return accessToken!;
};

// Initial scheduling of the token refresh
if (accessToken && tokenExpirationTime) {
	const remainingTime = tokenExpirationTime - Date.now();
	if (remainingTime > 0) {
		scheduleTokenRefresh(remainingTime / 1000);
	} else {
		fetchAccessToken();
	}
}
